import axios from "@/plugins/axios";

export function login(loginForm) {
  return axios({
    url: "Auth/AdminLogin",
    method: "POST",
    params: {
      ...loginForm,
      //   username: loginForm.username,
      //   password: loginForm.password,
    },
  });
}
